
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import AppState from '../../../js/AppState';
import classes from './ScoreProgressbar.module.css';
import { FaStar } from 'react-icons/fa6';
import Star from '../Star/Star';
import Minigames from '@/js/Minigames/Minigames';


const ScoreProgressbar = () => {

  var max = Minigames.maxStars
  var currentValue = Minigames.stars

  // var currentValue = 25

  var intermediates = [11, 22]

  return (
    <div className={classes.ScoreProgressbarCtnr}>
      <div className={classes.ScoreProgressbar}>
      <div className={classes.max}>
        <div className={classes.max_star}>
          <Star inBar filled={max === currentValue}>{max}</Star>
        </div>
      </div>
        <div className={classes.progressbar}>
          <div className={classes.bar} style={{height: currentValue / max * 100 + "%"}} />
          <div className={classes.levels}>
            {intermediates.map(i => {
              const filled = i <=currentValue
              return (
                <div key={i} className={clsx(classes.bar_palier)} style={{bottom: i / max * 100 + "%"}} >
                  <Star hideBlackLine inBar filled={filled} intermediate={ true }>{i}</Star>
                </div>
              )
            })}


            {currentValue < max &&
            <div className={classes.bar_currentvalue} style={{bottom: currentValue / max * 100 + "%"}} >
              <Star inBar filled>{currentValue}</Star>
            </div>}
          </div>
        </div>

      </div>
    </div>
  );
};

export default observer(ScoreProgressbar);
